import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { IKeepInTouchSystemJob } from '../../models/KeepInTouchAgent';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateKeepInTouchTemplateQueries } from './useKeepInTouchTemplateQuery';
import { invalidateKeepInTouchTemplatesQueries } from './useKeepInTouchTemplatesQuery';

export const useRunKeepInTouchJob = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: IKeepInTouchSystemJob) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (templateId: string) => {
			return userSession.webServiceHelper.callAsync<IKeepInTouchSystemJob>(
				`keepInTouch/templates/${encodeURIComponent(templateId)}/run`,
				'POST',
				null
			);
		},
		onError,
		onSuccess,
		onSettled: (_data, _error, templateId) => {
			invalidateKeepInTouchTemplatesQueries();
			invalidateKeepInTouchTemplateQueries({ id: templateId });
		},
	});
};
